import { jsx } from "react/jsx-runtime";
import { STEP_CONFIGS, STEP4_TOP_TITLE_SVG, LAYOUT } from "./constants.js";
function TitleStepSvg({ stepIndex, isAbsolute = false, bleedPx = 0 }) {
  const config = STEP_CONFIGS[stepIndex];
  if (!config) return null;
  const isStep23 = stepIndex >= 1 && stepIndex <= 2;
  const topOffset = (isStep23 ? 8 : 0) + (isAbsolute ? bleedPx : 0);
  const svg = isAbsolute && stepIndex === 3 ? STEP4_TOP_TITLE_SVG : config.svg;
  if (isAbsolute) {
    return /* @__PURE__ */ jsx("div", { className: "absolute", style: { left: LAYOUT.stepSvgLeft, top: LAYOUT.stepSvgTop + topOffset, zIndex: 1 }, children: /* @__PURE__ */ jsx("img", { src: svg, alt: "", width: config.svgWidth, height: config.svgHeight }) });
  }
  return /* @__PURE__ */ jsx("div", { style: { padding: `0 ${LAYOUT.step1SvgPadding}px` }, children: /* @__PURE__ */ jsx("img", { src: svg, alt: "", width: config.svgWidth, height: config.svgHeight }) });
}
export {
  TitleStepSvg
};
//# sourceMappingURL=TitleStepSvg.js.map
